import React, { useState, useRef } from "react";
import dos from "../../assets/tool_dd.png";
import kick from "../../assets/kc.png";
import contraction from "../../assets/tool_conc.png";
import trimister from "../../assets/tool_tc.png";
import video from "../../assets/tool_videos.png";
import right from "../../assets/right.png";
import Breadcrumbs from "../Breadcrumbs";
import bb from "../../assets/tool_bbyname.png";
import preproducts from "../../assets/tool_pr.png";
import excercise from "../../assets/tool_exe.png";
import healthprob from "../../assets/tool_chb.png";
import randomfacts from "../../assets/tool_rand.png";
import trimster1 from "../../assets/tri_chart.png";
import baby from "../../assets/tool_bn.png";
import calendar from "../../assets/tool_cal.png";
import yogas from "../../assets/tool_yogs.png";
import quote from "../../assets/tool_qt.png";
import hosp from "../../assets/tool_hsp.png";
// import allproducts from "../../assets/allproducts.png";
import { Link } from "react-router-dom";
function Home4() {
  const handleShowLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const googleMapsUrl = `https://www.google.com/maps/search/maternity+hospitals/@${latitude},${longitude},15z`;
          window.open(googleMapsUrl, "_blank");
        },
        (error) => {
          alert(
            "Unable to retrieve your location. Please enable location services."
          );
        }
      );
    } else {
      alert("Geolocation is not supported by your browser.");
    }
  };

  return (
    <div className="home4">
      <div className="pregs">
        <div>
          <h2 style={{ marginBottom: "27px" }}>Pregnancy tools</h2>
        </div>
        <div style={{ textDecoration: "none" }}>
          <div className="tooler">
            {/* <h5
              style={{
                color: "#000",
                cursor: "pointer",
                marginRight: "5px",
                fontSize:'21px'
              }}
            >
              more tools
            </h5> */}
            {/* 
            <img
              src={right}
              className="right-ar"
              alt="right-arrow"
              style={{ animation: "bouncer 1s infinite" }}
            /> */}
          </div>
        </div>
      </div>

      {/* Initial set of tools */}
      <div className="tab-fl" style={{ marginTop: "10px" }}>
        <div className="box">
          <Link className="dropdown-item" to="/dos-donts">
            <img src={dos} className="box-img" />
            <h5>Dos and Dont's</h5>
          </Link>
        </div>
        <div className="box">
          <Link className="dropdown-item" to="/kick-timer">
            <img src={kick} className="box-img1" />
            <h5>Kick Timer</h5>
          </Link>
        </div>
        <div className="box">
          <Link className="dropdown-item" to="/contraction">
            <img src={contraction} className="box-img2" />

            <h5>Contraction Timer</h5>
          </Link>
        </div>
        <div className="box">
          <Link className="dropdown-item" to="/checklist">
            <img src={trimister} className="box-img3" />

            <h5>Trimester Checklist</h5>
          </Link>
        </div>
        <div className="box">
          <Link to="/videos">
            <img src={video} className="box-img4" />
            <h5>Videos</h5>
          </Link>
        </div>
        <div className="box">
          <Link className="" to="/products">
            <img src={preproducts} className="box-img" />

            <h5>Pregnancy Products</h5>
          </Link>
        </div>

        <div className="box">
          <Link className="" to="/exercise">
            <img src={excercise} className="box-img2" />

            <h5>Excercise</h5>
          </Link>
        </div>
        <div className="box">
          <Link className="" to="/health-issues">
            <img src={healthprob} className="box-img2" />

            <h5>Common Health Problems</h5>
          </Link>
        </div>
        <div className="box">
          <Link className="" to="/random-facts">
            <img src={randomfacts} className="box-img2" />

            <h5>Random Facts</h5>
          </Link>
        </div>
        <div className="box">
          <Link className="dropdown-item" to="/trimester-chart">
            <img src={trimster1} className="box-img2" />

            <h5>Trimster Chart</h5>
          </Link>
        </div>
        {/* <div className="box">
          <Link className="dropdown-item" to="/babynames">
            <img src={baby} className="box-img2" />

            <h5>Baby Names</h5>
          </Link>
        </div> */}
        <div className="box">
          <Link className="dropdown-item" to="/pregnancy-yoga">
            <img src={yogas} className="box-img2" />

            <h5>Yoga</h5>
          </Link>
        </div>
        {/* <div className="box">
          <Link to="/calendar">
            <img src={calendar} className="box-img2" />
            <h5>Calendar</h5>
          </Link>
        </div> */}

        <div className="box">
          <Link to="/quotes">
            <img src={quote} className="box-img2" />
            <h5>Quotes</h5>
          </Link>
        </div>
        <div className="box">
          <Link to="/" onClick={handleShowLocation}>
            <img src={hosp} className="box-img2" />

            <h5>Near Maternal Hospitals</h5>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Home4;
